import "./style.scss";
import UPList from "./UPList/UPList";
import UPRegistration from "./UPRegistration/UPRegistration";

const UsersPageLayout = () => {
  return (
    <div className="container user-page">
      <UPList />
      <UPRegistration />
    </div>
  );
};

export default UsersPageLayout;
